import {getDomain} from 'tldts';

/**
 * Schemeful same-site key: URL scheme + registrable domain (eTLD+1 via PSL).
 * When PSL has no registrable domain (localhost, IPs), falls back to hostname.
 */
export function getSchemefulSite(url: URL): string {
  const registrableDomain = getDomain(url.hostname, {
    allowPrivateDomains: true,
  });
  const siteHost = registrableDomain ?? url.hostname;
  return `${url.protocol}//${siteHost}`;
}

/** True when two URLs are schemeful same-site (not merely same registrable domain). */
export function areSchemefulSameSite(a: URL, b: URL): boolean {
  return getSchemefulSite(a) === getSchemefulSite(b);
}
